import styled from "styled-components";
import { MEDIA_QUERY } from "../../entities/Common";

export const RootApplicationStyled = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .outlet-wrapper {
    width: calc(100% - 600px);
    min-height: 551px;
    box-sizing: border-box;
  }
  &._ACTION_EDIT_MIX {
    .mixture-tab {
      display: none;
    }
    .outlet-wrapper {
      width: calc(100% - 100px);
    }
  }

  @media (max-width: ${MEDIA_QUERY.LAPTOP}) {
    .outlet-wrapper {
      width: calc(100% - 100px);
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_HORIZONTAL}) {
    .outlet-wrapper {
      width: 100%;
    }
    &._ACTION_EDIT_MIX {
      aside {
        display: none;
      }
      .outlet-wrapper {
        width: 100%;
      }
    }
  }
  @media (max-width: ${MEDIA_QUERY.TABLET_VERTICAL}) {
    display: block;
    .outlet-wrapper {
      position: relative;
      z-index: 2;
    }
  }
`;
